export default __webpack_public_path__ + "static/media/uala-bis-logo-black.1cabb22d.svg";